import React from "react";
import { Card, Container } from "react-bootstrap";

const TermsAndConditions = () => {
  return (
    <Container className="my-5 site-content">
      <Card className="p-4">
        <Card.Body>
          <h1 className="text-center mb-4 fs-3">Terms & Conditions</h1>

          <section className="mb-4">
            <h2 className="fs-5">Introduction</h2>
            <p>
              This online payment system is provided by{" "}
              <b>
                Sheenlac Noroo Coatings Pvt. Ltd. (a unit of Sheenlac Paints
                Ltd.){" "}
              </b>{" "}
              may update these terms from time to time, and any changes will be
              effective immediately on being set out here. Please ensure you are
              aware of the current terms. The country of domicile for Sheenlac
              Noroo Coatings Pvt. Ltd. (a unit of Sheenlac Paints Ltd.) is
              India.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">Terms of Use</h2>
            <p>
              Please read these terms carefully before using the online payment
              facility. Using the online payment facility on this website
              indicates that you accept these terms. If you do not accept these
              terms, do not use this facility.
            </p>
            <p>All payments are subject to the following conditions:</p>
            <ul>
              <li>
                The description of services of match making are specific to your
                need when you log in with your unique password. Normally,
                payment is required in advance (i.e., before you commence your
                activity).
              </li>
              <li>
                All fees quoted are in Indian Rupees. Sheenlac Noroo Coatings
                Pvt. Ltd. (a unit of Sheenlac Paints Ltd.) reserves the right to
                change the fees at any time.
              </li>
              <li>
                Your payment will normally reach the Sheenlac Noroo Coatings
                Pvt. Ltd. (a unit of Sheenlac Paints Ltd.) account to which you
                are making a payment within two working days.
              </li>
              <li>
                We cannot accept liability for a payment not reaching the
                correct Sheenlac Noroo Coatings Pvt. Ltd. (a unit of Sheenlac
                Paints Ltd.) account due to you quoting an incorrect account
                number or incorrect personal details. Neither can we accept
                liability if payment is refused or declined by the credit/debit
                card supplier for any reason.
              </li>
              <li>
                If the card supplier declines payment, Sheenlac Noroo Coatings
                Pvt. Ltd. (a unit of Sheenlac Paints Ltd.) is under no
                obligation to bring this fact to your attention. You should
                check with your bank/credit/debit card supplier that payment has
                been deducted from your account.
              </li>
              <li>
                In no event will Sheenlac Noroo Coatings Pvt. Ltd. (a unit of
                Sheenlac Paints Ltd.) be liable for any damages whatsoever
                arising out of the use, inability to use, or the results of use
                of this site, any websites linked to this site, or the materials
                or information contained at any or all such sites, whether based
                on warranty, contract, tort, or any other legal theory and
                whether or not advised of the possibility of such damages.
              </li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">Refund Policy</h2>
            <p>
              If the Customer leaves Sheenlac Noroo Coatings Pvt. Ltd. (a unit
              of Sheenlac Paints Ltd.) before they complete their service
              period, there shall be no entitlement to a refund of paid service
              fees.
            </p>
            <p>
              Refunds, if applicable, at the discretion of the Management, will
              only be made to the debit/credit card used for the original
              transaction. For the avoidance of doubt, nothing in this Policy
              shall require Sheenlac Noroo Coatings Pvt. Ltd. (a unit of
              Sheenlac Paints Ltd.) to refund the Fees (or part thereof) unless
              such Fees (or part thereof) have previously been paid.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">Privacy Policy</h2>
            <p>
              This Privacy Policy applies to all of the products, services, and
              websites offered by Sheenlac Noroo Coatings Pvt. Ltd. (a unit of
              Sheenlac Paints Ltd.). Sometimes, we may post product-specific
              privacy notices or Help Centre materials to explain our products
              in more detail.
            </p>
            <p>
              If you have any questions about this Privacy Policy, please feel
              free to contact us through our website or write to us at.
            </p>
            <p>
              Information we collect and how we use it for our Sheenlac Noroo
              Coatings Pvt. Ltd. (a unit of Sheenlac Paints Ltd.).
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">Changes to Privacy Policy</h2>
            <p>
              Sheenlac Noroo Coatings Pvt. Ltd. (a unit of Sheenlac Paints Ltd.)
              reserves the entire right to modify/amend/remove this privacy
              statement anytime and without any reason. Nothing contained herein
              creates or is intended to create a contract/agreement between
              Sheenlac Noroo Coatings Pvt. Ltd. (a unit of Sheenlac Paints Ltd.)
              and any user visiting the Sheenlac Noroo Coatings Pvt. Ltd. (a
              unit of Sheenlac Paints Ltd.) website or providing identifying
              information of any kind.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="fs-5">DND Policy</h2>
            <p>
              If you wish to stop any further SMS/email alerts/contacts from our
              side, all you need to do is send an email to{" "}
              <a href="mailto:branding@sheenlac.in" className="link-secondary">
                branding@sheenlac.in
              </a>{" "}
              with your mobile numbers, and you will be excluded from the alerts
              list.
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TermsAndConditions;
